import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';

import { OrganizerPlanningPagePlanningComponent } from './components/pages/planning/planning.component';
import { OrganizerPlanningRoutingModule } from './planning-routing.module';
import { FullCalendarModule } from '@fullcalendar/angular';

/**
 * Organizer Activity management
 */
@NgModule({
  declarations: [OrganizerPlanningPagePlanningComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AuthModule,
    CommonModule,
    CoreModule,
    OrganizerPlanningRoutingModule,
    ComponentModule,
    OrganizerSharedModule,
    FullCalendarModule,
  ],
})
export class PlanningModule {}
